import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
  DoCheck,
  inject
} from '@angular/core';
import { selectorCoreFormCurrentPageStatus } from '@bepatient/core';
import { IonItem, IonTextarea } from '@ionic/angular';
import { Store } from '@ngrx/store';
import chroma from 'chroma-js';
import { Subscription } from 'rxjs';
import { TextAreaQuestionV3 } from '../../../classes/question-textarea';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-textarea-v3',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
  standalone: false
})
export class InputTextAreaComponentV3
  extends QuestionBaseV3ComponentDirective
  implements AfterViewInit, OnDestroy, DoCheck
{
  private store$ = inject<Store<any>>(Store);

  @Input() question: TextAreaQuestionV3;
  @Input() color: string;

  isBlur = true;
  hasError: boolean;
  subscription: Subscription;
  fieldErrors: Array<string>;
  dirty: boolean;

  @ViewChild(IonItem, { read: ElementRef, static: true })
  private ionItem: ElementRef;

  @ViewChild(IonTextarea, { read: ElementRef, static: true })
  private ionTextArea: ElementRef;

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngAfterViewInit(): void {
    this.ionItem.nativeElement.style.setProperty(
      '--input-valid-background',
      chroma(this.color).alpha(0.1).css()
    );
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onBlur(): void {
    this.isBlur = true;
    this.formGroup.get(this.question.key).markAsDirty();
  }

  onFocus(): void {
    this.isBlur = false;
  }

  onInput(): void {
    this.isBlur = false;
  }

  isEmpty(): boolean {
    return !this.ionTextArea.nativeElement.value;
  }

  onChange(): void {
    this.isBlur = false;
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.controls[this.question.key].dirty;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
